import { createContext } from 'react';

import { OnboardingContextProvider } from './OnboardingContextProvider';
import { useOnboardingContext } from './useOnboardingContext';
import { Channel } from '../../types/ChannelType';

export type ProfileData = {
  fullName: string;
  phone?: string;
  location?: string;
  marketingOptIn: boolean;
};

export type OnboardingData = {
  fullName: string;
  marketingOptIn: boolean;
  phone?: string;
  location?: string;
  building?: Channel;
  company?: Channel;
};

export type OnboardingProfile = {
  fullName: string | undefined;
  isMarketingOptInSelected: boolean;
  phone?: string;
  location?: string;
};

export enum OnboardingState {
  Idle = 'idle',
  Loading = 'loading',
  Error = 'error',
}

export type OnboardingContextType = {
  data: {
    profile: OnboardingProfile;
    building?: Channel;
    company?: Channel;
    selectedBuilding?: Channel;
  };
  errors: {
    completionError: string | undefined;
  };
  hasProfileNameBeenUpdated?: boolean;
  onboardingState: OnboardingState;
  handlers: {
    updateProfile: ({
      fullName,
      marketingOptIn,
      phone,
      location,
    }: ProfileData) => void;
    completeOnboarding: (data: OnboardingData) => Promise<void>;
    onBuildingOrCompanySelectionChange: () => void;
    updateSelectedBuilding: (building?: Channel) => void;
  };
};

export const OnboardingContext = createContext<
  OnboardingContextType | undefined
>(undefined);

export { OnboardingContextProvider, useOnboardingContext };
